import React, {useState} from "react";
import Icon from "../ui/Icon";
import moment from "moment";
import {useAuth} from "../../hooks/useAuth";
import CustomButton from "../ui/CustomButton";
import * as XLSX from "xlsx";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export interface ExportButtonProps {
    buildRequestParams: () => any;
    fetchData: (params: any) => Promise<any[]>;
    isExportingFromBackend?: boolean;
    mapRow?: (row: any) => Record<string, any>;
    buildFileName?: () => string;
    label?: string;
}

const ExportButton = ({
                          buildRequestParams,
                          fetchData,
                          isExportingFromBackend = false,
                          mapRow,
                          buildFileName,
                          label = "Exportă",}: ExportButtonProps) => {
    const { update, tenant } = useAuth();
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
    const [loading, setLoading] = useState(false);

    const exportXlsx = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setLoading(true);

        const handleMap = mapRow ? mapRow : (row: any) => row;

        try {
            const params = buildRequestParams();
            const exportResponse =  await fetchData(params);

            if((isExportingFromBackend && !exportResponse) || (!exportResponse || exportResponse.length === 0)) {
                update("error", {
                    show: true,
                    closable: true,
                    title: "Nu exista date pentru export",
                    message: "",
                    icon: "fat face-eyes-xmarks",
                    button: "ÎNCHIDE",
                });
                return;
            }

            if(isExportingFromBackend && exportResponse) {
                update("error", {
                    show: true,
                    closable: true,
                    title: "Exportul este în curs de generare",
                    message: "Vei primi în cel mai scurt timp un mesaj cu linkul necesar descărcării fișierului.",
                    icon: "fat face-smile",
                    button: "ÎNCHIDE",
                });
            } else {
                const data = exportResponse.map(handleMap);
                const ws = XLSX.utils.json_to_sheet(data);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "SheetJS");

                const defaultFileName = `${tenant.name}-${moment().format("DD.MM.YYYY")}.xlsx`;
                const fileName = buildFileName ? buildFileName() : defaultFileName;

                XLSX.writeFile(wb, fileName);
            }


        } catch (err) {
            update("error", { show: true, code: "A001" });
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <CustomButton
            onClick={exportXlsx}
            disabled={loading}
            className="exportIcon"
            buttonType="textIcon"
            bgcolor="paper"
            sxExtra={{
                marginLeft: 1.5,
                color: "secondary.main",
                backgroundColor: "transparent",
                "&:hover": {
                    color: "secondary.light",
                    backgroundColor: "transparent",
                },
                "&[aria-expanded='true']": {
                    backgroundColor: "white",
                },
            }}
            icon={loading ?
                <Icon
                    icon="far circle-notch"
                    spin={true}
                    className="fa-faster"
                    fixedWidth={true}
                    sx={{display: "inline-flex", marginBottom: "2px",}}
                    style={{width: "1.2rem", height: "1.2rem",}}
                /> :
                <Icon
                    icon="far arrow-down-to-line"
                    fixedWidth={true}
                    sx={{display: "inline-flex", marginBottom: "2px",}}
                    style={{width: "1.2rem", height: "1.2rem",}}
                />}
        >
            {isMdUp ? label : ""}
        </CustomButton>
    )
}

export default ExportButton;